import React, { ReactNode } from "react";
import { NavLink } from "react-router-dom";

interface TabBarItem {
  path: string;
  title: string;
}

interface TabBarProps {
  items?: TabBarItem[];
  children?: ReactNode;
  title?: string;
}

function TabBar({ items, children, title }: TabBarProps) {
  return (
    <div className="bg-white dark:bg-slate-800 rounded-[8px] shadow-md shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 px-3 py-2 mb-3">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2.5">
        {/* Title */}
        {title && (
          <h2 className="text-sm font-bold text-slate-800 dark:text-slate-200 uppercase">
            {title}
          </h2>
        )}

        {/* Tabs and Children Container */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2.5">
          {/* Custom Children (buttons, etc.) */}
          {children && <div className="flex-shrink-0">{children}</div>}

          {/* Tab Navigation */}
          {items && items.length > 0 && (
            <nav className="flex flex-wrap gap-1.5">
              {items.map((item, i) => {
                if (!item.path.includes(":")) {
                  return (
                    <NavLink
                      key={i}
                      to={item.path}
                      className={({ isActive }) =>
                        `px-3 py-1.5 rounded-lg text-[10px] font-medium uppercase transition-all duration-200 ${
                          isActive
                            ? "bg-gradient-to-r from-primary to-primaryLight text-white shadow-md shadow-primary/20"
                            : "bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-600 hover:text-slate-800 dark:hover:text-slate-200"
                        }`
                      }
                    >
                      {item.title}
                    </NavLink>
                  );
                }
                return null;
              })}
            </nav>
          )}
        </div>
      </div>
    </div>
  );
}

export default TabBar;
